import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { SubmitChatSurveyRPC } from "./submitChatSurveyRPC";

export class SubmitChatSurveyRPCClientImpl extends SubmitChatSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: SubmitChatSurveyRPC.Request): Promise<LeoRPCResult<SubmitChatSurveyRPC.Response, SubmitChatSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/SubmitChatSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      SubmitChatSurveyRPC.ResponseDTO,
      SubmitChatSurveyRPC.Errors.ErrorsDTO,
      SubmitChatSurveyRPC.Response,
      SubmitChatSurveyRPC.Errors.Errors
    >(
      response,
      "survey-respondent/SubmitChatSurvey",
      SubmitChatSurveyRPC.Response.fromDTO,
      SubmitChatSurveyRPC.Errors.fromDTO
    );
  }
}
